import { useEffect, useContext } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import GlobalContext from '../../../contexts';
import translating from '../translate.json';
import useFetchData from 'hooks/useFetchData';
import fields from '../fields';
import { useNavigate } from 'react-router-dom';

const CreateGeneparam = () => {
  const { data: subCategoriesData } = useFetchData('report-text/SubCategoris');
  const navigate = useNavigate();
  const { postData, res } = usePostData();
  const { categoriesList, setLink } = useContext(GlobalContext);

  useEffect(() => {
    if (res?.id) {
      setLink(null);
      navigate(`/labs/gene?added=true`);
    }
  }, [res]);

  const onSubmit = (data) => {
    postData('gene-analyze', data);
  };
  return (
    <div className="create-gene">
      <SectionHeader title={translating.createGeneParam}></SectionHeader>
      <FormGroup
        fields={fields(subCategoriesData, true)}
        onSubmit={onSubmit}
        categories={categoriesList}
      ></FormGroup>
    </div>
  );
};

export default CreateGeneparam;
